<template>
    <v-app id="inspire" class="app">
        <app-drawer class="app--drawer"></app-drawer>
        <app-toolbar class="app--toolbar"></app-toolbar>
        <v-content>
          <!-- Page Header -->
          <page-header v-if="$route.meta.breadcrumb"></page-header>
          <div class="page-wrapper">
              <slot></slot>
          </div>
          <!-- App Footer -->
        </v-content>
        <!-- Go to top -->
        <app-fab></app-fab>
        <!-- theme setting -->

        <v-navigation-drawer
          class="setting-drawer"
          temporary
          right
          v-model="rightDrawer"
          hide-overlay
          fixed
        ></v-navigation-drawer>
  </v-app>
</template>


<script>
    import AppDrawer from "@/components/AppDrawer";
    import AppToolbar from "@/components/AppToolbar";
    import AppFab from "@/components/AppFab";
    import PageHeader from "@/components/PageHeader";
    import ThemeSettings from "@/components/ThemeSettings";
    import AppEvents from "../../event";
    
    
    export default {
      components: {
        AppDrawer,
        AppToolbar,
        AppFab,
        PageHeader,
        ThemeSettings
      },
      data() {
          return {
            expanded: true,
            rightDrawer: false,
            snackbar: {
              show: false,
              text: "",
              color: ""
            }
          }
      }
    }
</script>


<style lang="stylus" scoped>
    .setting-fab {
      top: 50% !important;
      right: 0;
      border-radius: 0;
    }

    .page-wrapper {
        width: 100% !important;
        overflow: hidden;
        min-height: calc(100vh - 64px - 50px - 81px);
    }
</style>